import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import outline from 'base/style_mixins/outline';

const styles = theme => ({
  buttonWrapper: {
    position: 'absolute',
    right: ({ right = 0 }) => theme.spacing(right),
    top: ({ top = 0 }) => theme.spacing(top),
    zIndex: theme.zIndex.mobileStepper
  },
  button: {
    '&:focus': {
      ...outline
    }
  },
  icon: {
    fill: ({ color }) => color
  }
});

const CloseButton = ({ handleClick, classes, autoFocus }) => {
  return (
    <Box position="relative">
      <Box className={classes.buttonWrapper}>
        <IconButton
          autoFocus={autoFocus}
          aria-label="Close"
          onClick={handleClick}
          className={classes.button}
          data-testid="close-button"
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      </Box>
    </Box>
  );
};

CloseButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  classes: PropTypes.shape({ closeIcon: PropTypes.string }),
  autoFocus: PropTypes.bool
};

export default withStyles(styles)(CloseButton);
